const cellEvents: string[] = [
  'cellClick',
  'cellDblClick',
  'cellContext',
  'cellTap',
  'cellDblTap',
  'cellTapHold',
  'cellMouseEnter',
  'cellMouseLeave',
  'cellMouseOver',
  'cellMouseOut',
  'cellMouseMove',
  'cellEditing',
  'cellEditCancelled',
  'cellEdited',
];

export default cellEvents;
